import associate from './associate-user.gql'
import create from './create-opportunity.gql'
import get from './get-opportunity.gql'
import opportunityFragment from './opportunity.fragment.gql'
import savedVehicleFragment from './saved-vehicle.fragment.gql'
import updateConsumer from './update-consumer.gql'
import verifyAccess from './verify-access.gql'

const opportunityReload = opportunityFragment + savedVehicleFragment

const associateUser = associate + opportunityReload
const createOpportunity = create + opportunityReload
const getOpportunity = get + opportunityReload

export {
  associateUser,
  createOpportunity,
  getOpportunity,
  opportunityFragment,
  savedVehicleFragment,
  updateConsumer,
  verifyAccess
}
